import styled from 'styled-components'
import { components } from 'react-select'

import { InnerComponent } from 'components/utils/innerReactSelectComponents'

const StyledMenu = styled(InnerComponent).attrs({ Component: components.Menu })`
  &.react-select__menu {
    font-size: 14px;
    margin-top: 7px;
    left: -8px;
    min-width: 96px;
    width: fit-content;
    border-radius: 0;
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.29);
  }
`

const Menu = (props) => {
  return (
    <StyledMenu {...props} />
  )
}

export default Menu
